import React, { useState } from "react";
import { X, Play } from "lucide-react";
import { Layout } from "../components/Layout";
import { LotusMark } from "../components/Logo";
import { gallery } from "../data/gallery";

export const GalleryPage = () => {
  const [active, setActive] = useState(null); // index of opened image

  const openImage = (item, i) => {
    if (item.type === "image") setActive(i);
  };

  return (
    <Layout>
      <section className="pt-28 md:pt-32 pb-12">
        <div className="container mx-auto px-6 text-center max-w-3xl">
          <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary/10 text-primary text-xs font-semibold uppercase tracking-widest mb-5">
            <LotusMark className="w-4 h-4" /> Gallery
          </span>
          <h1 className="font-heading text-4xl md:text-5xl font-semibold text-charcoal mb-4">
            Moments on the mat
          </h1>
          <p className="text-charcoal/70 text-lg">
            A glimpse of our practice — sessions, poses and the spirit of
            Yogarambh.
          </p>
        </div>
      </section>

      <section className="pb-24">
        <div className="container mx-auto px-6">
          <div className="columns-1 sm:columns-2 lg:columns-3 gap-5 [column-fill:_balance]">
            {gallery.map((item, i) => (
              <div
                key={i}
                className="mb-5 break-inside-avoid rounded-2xl overflow-hidden border border-accent/15 shadow-soft bg-white group relative cursor-pointer"
                onClick={() => openImage(item, i)}
              >
                {item.type === "video" ? (
                  <div className="relative">
                    <iframe
                      src={item.src}
                      title={item.alt}
                      className="w-full aspect-video"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                    />
                    <span className="absolute top-3 left-3 inline-flex items-center gap-1 bg-primary text-white text-xs px-2 py-1 rounded-full">
                      <Play className="w-3 h-3" /> Video
                    </span>
                  </div>
                ) : (
                  <img
                    src={item.src}
                    alt={item.alt}
                    loading="lazy"
                    className="w-full object-cover group-hover:scale-[1.03] transition-transform duration-500"
                  />
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Lightbox */}
      {active !== null && gallery[active] && (
        <div
          className="fixed inset-0 z-[70] bg-charcoal/80 backdrop-blur-sm flex items-center justify-center p-4"
          onClick={() => setActive(null)}
        >
          <button
            type="button"
            aria-label="Close"
            className="absolute top-5 right-5 text-white/90 hover:text-white"
            onClick={() => setActive(null)}
          >
            <X className="w-8 h-8" />
          </button>
          <img
            src={gallery[active].src}
            alt={gallery[active].alt}
            className="max-h-[85vh] max-w-full rounded-2xl shadow-soft-lg"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </Layout>
  );
};

export default GalleryPage;
